import React from "react";
import UserIcon from "../icons/UserIcon";

const UserMenu = () => {
  return (
    <div className="user-account">
      <a href={$("#LOGIN_URL").val()} className="btn">
        <UserIcon />
        <span className="d-none d-sm-block">{gettext("Login")}</span>
      </a>
    </div>
  );
};

export default UserMenu;
